(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["vue-table-of-content"] = factory();
	else
		root["vue-table-of-content"] = factory();
})((typeof self !== 'undefined' ? self : this), () => {
return /******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	// The require scope
/******/ 	var __webpack_require__ = {};
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/publicPath */
/******/ 	(() => {
/******/ 		__webpack_require__.p = "";
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": () => (/* binding */ entry_lib)
});

;// CONCATENATED MODULE: ../../node_modules/@vue/cli-service/lib/commands/build/setPublicPath.js
/* eslint-disable no-var */
// This file is imported into lib/wc client bundles.

if (typeof window !== 'undefined') {
  var currentScript = window.document.currentScript
  if (false) { var getCurrentScript; }

  var src = currentScript && currentScript.src.match(/(.+\/)[^/]+\.js(\?.*)?$/)
  if (src) {
    __webpack_require__.p = src[1] // eslint-disable-line
  }
}

// Indicate to webpack that this file can be concatenated
/* harmony default export */ const setPublicPath = (null);

;// CONCATENATED MODULE: ../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[2]!../../node_modules/pug-plain-loader/index.js!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/VueTableOfContent.vue?vue&type=template&id=8a9ffce4&scoped=true&lang=pug&
var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',{directives:[{name:"show",rawName:"v-show",value:(_vm.visible),expression:"visible"}],ref:"tocNav",staticClass:"sf-mobile-toc",class:{ 'sf-mobile-toc--open': _vm.tocOpened, 'sf-mobile-toc--top': _vm.position === 'top', 'sf-mobile-toc--bottom': _vm.position === 'bottom' },attrs:{"id":"sf-mobile-toc","aria-labelledby":'toc_button' + _vm.uuid}},[_c('transition',{attrs:{"name":"toc-slide"}},[_c('ul',{directives:[{name:"show",rawName:"v-show",value:(_vm.tocOpened),expression:"tocOpened"}],staticClass:"sf-mobile-toc__list sf-list sf-list--empty",attrs:{"id":'toc_menu' + _vm.uuid,"role":"navigation","aria-labelledby":'toc_button' + _vm.uuid,"aria-expanded":'' + _vm.tocOpened,"aria-hidden":'' + !_vm.tocOpened}},_vm._l((_vm.items),function(item){return _c('li',{staticClass:"sf-mobile-toc__list-item"},[_c('a',{class:{ 'active' : _vm.activeElement == item.name },attrs:{"id":item.name,"href":`#${item.name}`},on:{"click":function($event){$event.preventDefault();return _vm.scrollToItem(item.name, item.pageIndex)}}},[_vm._v(_vm._s(item.text))])])}),0)]),_c('button',{ref:"tocButton",staticClass:"sf-mobile-toc__button",attrs:{"id":'toc_button' + _vm.uuid,"type":"button","aria-controls":"toc_menu","aria-haspopup":"true","aria-expanded":'' + _vm.tocOpened},on:{"click":function($event){_vm.tocOpened = !_vm.tocOpened}}},[_c('span',{staticClass:"sr-only"},[_vm._v(_vm._s(_vm.$t('choosenBookmark')))]),_c('svg',{attrs:{"width":"14","height":"8","viewBox":"0 0 14 8","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M0.999999 7L7 0.999999L13 7","stroke":"#52AE30","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}})])])],1)
}
var staticRenderFns = []


;// CONCATENATED MODULE: ../../node_modules/@ui-common/sf-js-utils/dist/sf-js-utils.esm.js
var t=Object.freeze({__proto__:null,ADDRESS_CARD:"^\\d{6}[a-zA-Z]{2}$",ALL_PHONE:["^1\\s\\d{3}\\s\\d{4}$","^[02-9]\\d\\s\\d{3}\\s\\d{3,4}$","^(70|20|30|31)\\s\\d{3}\\s\\d{4}$"],BANK_ACCOUNT_SIXTEEN_NUMBERS:"^\\d{8}-\\d{8}$",BANK_ACCOUNT_THIRTEEN_NUMBERS:"^\\d{5}-\\d{8}$",BANK_ACCOUNT_TWENTY_FOUR_NUMBERS:"^\\d{8}-\\d{8}-\\d{8}$",DATE_SEPARATORS:/[.,\/ -]/,DEVIZA_BANK_ACCOUNT_NUMBER_PATTERN:"^75\\d{3}-\\d{5}88\\d$",FOREIGN_PHONE_REGEX:/^\d{1,3}-\d{1,10}$/,FOREIGN_ZIP_CODE:/^[\da-zA-Z]{1,10}$/g,FULLNAME:"^(.+[ ].+)$|^$",HEX:/#[0-9a-fA-F]{6}/,IDENTITYS:{"personal-id":"^\\d{6}[a-zA-Z]{2}$","drivers-license":"^[a-zA-Z]{2}\\d{6}$",passport:"[a-zA-Z]{2}\\d{7}$"},IOS:/ipad|iphone/i,LANDLINE_PHONES:["^1\\s\\d{3}\\s\\d{4}$","^[02-9]\\d\\s\\d{3}\\s\\d{3,4}$"],LAST_FOUR_DIGITS:/^\d{4}$/,MOBILE_PHONE:"^(70|20|30|31)\\s\\d{3}\\s\\d{4}$",NAME:"^[\\p{L}\\s\\.\\-\\']*$",PENSIONER_NUMBER:"^\\d{3}-\\d{5}-\\d{1}$",TAX_NUMBER:"^\\d{8}-\\d{1}-\\d{2}$",YEAR:"^\\d{4}$",ZIP_CODE:"^\\d{4}$"});var e=Object.freeze({__proto__:null,HUNGARIAN_PHONE_NUMBER_PREFIX:"+36",OTP_BANK_ACCOUNT_NUMBER_PREFIX:"117"});var r=Object.freeze({__proto__:null,COOKIE_GDPR_LEVEL:"gdpr_level",GDPR_LEVELS:{LOW:1,MEDIUM:2,HIGH:3}});var d=Object.freeze({__proto__:null,BACKEND_DATE:"YYYY-MM-DD",DISPLAY_DATE:{hu:"YYYY.MM.DD.",en:"MM/DD/YYYY"},DISPLAY_TIME:{hu:"HH:mm",en:"hh:mm A"}});function i(){window.onkeydown=function(t){"Space"===t.code&&t.target==document.body&&t.preventDefault()}}function o(t){for(var e=0,r=0;t;){if("BODY"==t.tagName){var d=t.scrollLeft||document.documentElement.scrollLeft,i=t.scrollTop||document.documentElement.scrollTop;e+=t.offsetLeft-d+t.clientLeft,r+=t.offsetTop-i+t.clientTop}else e+=t.offsetLeft-t.scrollLeft+t.clientLeft,r+=t.offsetTop-t.scrollTop+t.clientTop;t=t.offsetParent}return{x:e,y:r}}function s(t){let e=[],r=t.parentNode.firstChild;for(;r;)1===r.nodeType&&r!==t&&e.push(r),r=r.nextSibling;return e}function n(t,e,r){return r=r?parseInt(r,10):0,"number"==typeof e?t.slice(r,r+e):t}function p(t){return void 0!==t&&null!=t?Math.floor(t/12)+" év":""}const u=767,_=959,h=1279;var a={data:()=>({viewportWidth:null}),methods:{setViewportWidth(){this.viewportWidth=window.innerWidth}},computed:{isMobile(){return this.viewportWidth<=u},isTablet(){return this.viewportWidth>u&&this.viewportWidth<_},isDesktop(){return this.viewportWidth>_&&this.viewportWidth<h},isLargeDesktop(){return this.viewportWidth>h}},created(){window.addEventListener("resize",this.setViewportWidth),this.setViewportWidth()},mounted(){this.setViewportWidth()},beforeDestroy(){window.removeEventListener("resize",this.setViewportWidth)}},E=(t=8)=>{let e="";const r="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";for(let d=0;d<t;d++)e+=r.charAt(Math.floor(62*Math.random()));return e},l={data(){return{uuid:this.id||E()}},props:{id:{required:!1,type:String}}},N={mixins:[l],props:{errorId:{required:!1,type:String},addonId:{required:!1,type:String},prefixId:{required:!1,type:String},tooltipId:{required:!1,type:String},addon:{type:String,required:!1},prefix:{type:String,required:!1}},computed:{computedAddonId(){const t=this.addon?`${this.uuid}-addon`:null;return this.addonId||t},computedPrefixId(){const t=this.prefix?`${this.uuid}-prefix`:null;return this.prefixId||t},ariaDescribedBy(){const t=[];return this.$attrs["aria-describedby"]&&t.push(this.$attrs["aria-describedby"]),this.errorId&&t.push(this.errorId),this.computedAddonId&&t.push(this.computedAddonId),this.computedPrefixId&&t.push(this.computedPrefixId),this.tooltipId&&t.push(this.tooltipId),t.join(" ")}}},c={props:{hasError:{type:Boolean,required:!1,default:!1}}};

;// CONCATENATED MODULE: ./src/components/VueTableOfContent.lang.json
const VueTableOfContent_lang_namespaceObject = JSON.parse('{"hu":{"choosenBookmark":"Kiválasztott könyvjelző"},"en":{"choosenBookmark":"Choosen bookmark"}}');
;// CONCATENATED MODULE: ./src/components/constants.js
const POSITION = {
	TOP: 'top',
	BOTTOM: 'bottom'
};

;// CONCATENATED MODULE: ../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/VueTableOfContent.vue?vue&type=script&lang=js&





/* harmony default export */ const VueTableOfContentvue_type_script_lang_js_ = ({
	mixins: [l],
	name: 'VueTableOfContent',
	i18n: { messages: VueTableOfContent_lang_namespaceObject },
	data() {
		return {
			bookmarkHeights: [],
			bookmarkTitle: null,
			tocOpened: false,
			stickyTop: null,
			visible: false,
			offsetHeight: 0,
			scroll: 0,
			activeElement: null,
			prevScrollTop: null
		};
	},
	props: {
		/**
		 * Array of items listed in the component
		 *
		 * e.g. [{"name":"fooldal","text":"Főoldal", pageIndex: 0}, ... ]
		 */
		items: {
			type: Array,
			required: true
		},
		position: {
			type: String,
			default: POSITION.BOTTOM,
			validator(val) {
				return Object.values(POSITION).includes(val);
			}
		},
		activePage: {
			type: Number,
			required: false,
			default: -1
		},
		jumpToPageFn: {
			type: Function,
			required: false,
			default: () => {}
		}
	},
	methods: {
		onScroll() {
			let bookmarks = [...document.querySelectorAll('.bookmark')].reverse();
			this.bookmarkHeights = bookmarks.map((bookmark) => {
				return {
					id: bookmark.getAttribute('id'),
					height: o(bookmark).y - this.computedOffsetHeight,
					text: bookmark.getAttribute('data-text')
				};
			});
			let scrollTop = window.scrollY || document.body.scrollTop;
			this.visible = scrollTop > 40;
			if (this.bookmarkHeights[this.bookmarkHeights.length - 1].height > 0) {
				this.bookmarkTitle = this.$t('defaultText');
			} else {
				let i = 0;
				do {
					this.bookmarkTitle = this.bookmarkHeights[i].text;
					i++;
				} while (i < this.bookmarkHeights.length && this.bookmarkHeights[i - 1].height > 0);
			}
			++this.scroll;
			this.$nextTick(() => {
				this.setActiveElement();
			});
		},
		async scrollToItem(id, itemPage) {
			await this.jumpToPage(itemPage);
			this.tocOpened = false;
			this.doScroll(id);
		},
		doScroll(id) {
			setTimeout(() => {
				if (this.$refs.tocNav && this.$refs.tocNav.classList.contains('sf-mobile-toc--open')) {
					this.doScroll(id);
				} else {
					if (this.$refs.tocButton) {
						this.offsetHeight = parseInt(getComputedStyle(this.$refs.tocButton).height, 10);
						this.$scrollTo(document.getElementById(id), {
							offset: -this.computedOffsetHeight,
							onDone: () => {
								this.onScroll();
								setTimeout(() => {
									this.$scrollTo(document.getElementById(id), { offset: -this.computedOffsetHeight });
								});
							}
						});
					}
				}
			});
		},
		setActiveElement() {
			const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
			const scrollDirection = scrollTop > this.prevScrollTop ? 'down' : 'up';
			const itemArray = scrollDirection == 'down' ? [...this.items].map((obj) => ({ ...obj })) : [...this.items].reverse().map((obj) => ({ ...obj }));
			itemArray.forEach((item) => {
				const element = document.getElementById(item.name);
				const rect = element.getBoundingClientRect();
				const offsetHeight = document.getElementById('sf-mobile-toc')?.offsetHeight || 0;
				if (
					rect.top >= 0 &&
					rect.left >= 0 &&
					rect.bottom <= (window.innerHeight - offsetHeight || document.documentElement.clientHeight - offsetHeight) &&
					rect.right <= (window.innerWidth || document.documentElement.clientWidth)
				) {
					this.activeElement = item.name;
					return;
				}
			});
			this.prevScrollTop = scrollTop;
		},
		async jumpToPage(itemPage) {
			if (itemPage === null || this.activePage == -1) return;
			if (itemPage != this.activePage) {
				this.jumpToPageFn(itemPage);
				await this.$nextTick();
			}
		}
	},
	computed: {
		computedOffsetHeight() {
			return this.scroll && this.$refs.tocButton ? parseInt(getComputedStyle(this.$refs.tocButton).height, 10) : 0;
		}
	},
	watch: {
		tocOpened(value) {
			if (value === false) {
				this.offsetHeight = this.$refs.tocButton ? parseInt(getComputedStyle(this.$refs.tocButton).height, 10) : 0;
			}
		}
	},
	mounted() {
		this.bookmarkTitle = this.$t('defaultText');
		this.prevScrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
		this.setActiveElement();
		window.addEventListener('scroll', this.onScroll);
	}
});

;// CONCATENATED MODULE: ./src/components/VueTableOfContent.vue?vue&type=script&lang=js&
 /* harmony default export */ const components_VueTableOfContentvue_type_script_lang_js_ = (VueTableOfContentvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ../../node_modules/@vue/cli-service/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-61.use[0]!../../node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-61.use[1]!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!../../node_modules/@vue/cli-service/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-61.use[2]!../../node_modules/sass-loader/dist/cjs.js??clonedRuleSet-61.use[3]!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/VueTableOfContent.vue?vue&type=style&index=0&id=8a9ffce4&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/VueTableOfContent.vue?vue&type=style&index=0&id=8a9ffce4&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

function normalizeComponent(
  scriptExports,
  render,
  staticRenderFns,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */,
  shadowMode /* vue-cli only */
) {
  // Vue.extend constructor export interop
  var options =
    typeof scriptExports === 'function' ? scriptExports.options : scriptExports

  // render functions
  if (render) {
    options.render = render
    options.staticRenderFns = staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = 'data-v-' + scopeId
  }

  var hook
  if (moduleIdentifier) {
    // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = shadowMode
      ? function () {
          injectStyles.call(
            this,
            (options.functional ? this.parent : this).$root.$options.shadowRoot
          )
        }
      : injectStyles
  }

  if (hook) {
    if (options.functional) {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functional component in vue file
      var originalRender = options.render
      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context)
        return originalRender(h, context)
      }
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook]
    }
  }

  return {
    exports: scriptExports,
    options: options
  }
}

;// CONCATENATED MODULE: ./src/components/VueTableOfContent.vue



;


/* normalize component */

var component = normalizeComponent(
  components_VueTableOfContentvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  "8a9ffce4",
  null
  
)

/* harmony default export */ const VueTableOfContent = (component.exports);
;// CONCATENATED MODULE: ../../node_modules/@vue/cli-service/lib/commands/build/entry-lib.js


/* harmony default export */ const entry_lib = (VueTableOfContent);


__webpack_exports__ = __webpack_exports__["default"];
/******/ 	return __webpack_exports__;
/******/ })()
;
});
//# sourceMappingURL=vue-table-of-content.umd.js.map